import http from "api/https";

// Клиент домена пользовательских соглашений (AgreementController).
// Поля ответов — snake_case: бэкенд сериализует Newtonsoft со SnakeCaseNamingStrategy (Program.cs).

/** Код пользовательского соглашения в реестре agreement (стабильный ключ чтения). */
export const PERSONAL_DATA_AGREEMENT = "personal_data_agreement";

export interface ActiveAgreementVersion {
  agreement_id: number;
  code: string;
  version_id: number;
  version_no: number;
  requires_signature: boolean;
  blocks_login: boolean;
  effective_from: string | null;
  name_ru: string;
  name_kg: string | null;
  content_ru: string;
  content_kg: string | null;
}

export interface PendingAgreement {
  agreement_id: number;
  code: string;
  version_id: number;
  version_no: number;
  blocks_login: boolean;
  name_ru: string;
  name_kg: string | null;
}

/** Активная редакция соглашения по коду. Анонимный эндпоинт. */
export const getActiveAgreement = (code: string): Promise<any> => {
  return http.get(`/api/v1/Agreement/GetActive?code=${encodeURIComponent(code)}`);
};

/**
 * Акцепт редакции с квалифицированной подписью. Анонимный эндпоинт: подпись выполняется
 * до создания пользователя. Возвращает { acceptance_id }.
 */
export const acceptAgreement = (
  versionId: number,
  pin: string,
  code: string,
  pinOrganization?: string,
  customerContacts?: { email?: string; phone?: string }
): Promise<any> => {
  return http.post(`/api/v1/Agreement/Accept`, {
    version_id: versionId,
    pin,
    code,
    ...(pinOrganization ? { pin_organization: pinOrganization } : {}),
    // Реквизиты заказчика для текста соглашения. Нужны только при подписи из формы регистрации:
    // пользователя ещё нет в БД. Для залогиненного подписанта сервер берёт их из учётной записи.
    ...(customerContacts?.email ? { customer_email: customerContacts.email } : {}),
    ...(customerContacts?.phone ? { customer_phone: customerContacts.phone } : {}),
  });
};

/** Неподписанные обязательные редакции текущего пользователя. Требует авторизации. */
export const getPendingAgreements = (): Promise<any> => {
  return http.get(`/api/v1/Agreement/GetPending`);
};
